import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { HTTPError } from 'ky';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';
import { BFFClient } from '~settings/api/lib/BFFClient';
import { getRequestHeaders } from '~settings/api/lib/headers';
import type { SublabelRequest } from '~settings/api/lib/schemas';
import type { SublabelRequestPayload } from '~settings/api/lib/types';

export const useSublabelRequestCreate = (
  options?: UseMutationOptions<
    SublabelRequest,
    HTTPError,
    SublabelRequestPayload
  >,
) => {
  const { token } = useWmgSession();

  return useMutation<SublabelRequest, HTTPError, SublabelRequestPayload>({
    mutationFn: async (labelData) => {
      return BFFClient.post('sublabel-requests', {
        json: labelData,
        headers: getRequestHeaders(token),
      }).json();
    },
    onError: (error) => {
      console.error('Create label failed:', error);
    },
    ...options,
  });
};
